import axios from "axios";
import {
    baseUrl
} from "./utils";
import {
    setUserData,
    setBearerToken
} from "./userActions";
import {
    showError
} from "./error";

export const CLEAR_LOGIN_STATUS = "CLEAR_LOGIN_STATUS";
export const SET_LOGIN_ATTEMPT = "SET_LOGIN_ATTEMPT";
export const loginStatus = {
    none: "NONE", // User hasn't tried to login yet
    inProgress: "IN_PROGRESS", // User has requested a login attempt
    notVerified: "NOT_VERIFIED", // User has not yet verified
    success: "SUCCESS", // Login attempt was successful
    fail: "FAIL" // Login attempt was unsuccessful
}

export function clearLoginStatus() {
    return {
        type: CLEAR_LOGIN_STATUS
    }
}

export function setLoginAttempt(status) {
    return {
        type: SET_LOGIN_ATTEMPT,
        status: status
    }
}

export function requestLogin(dispatch, login) {
    dispatch(setLoginAttempt(loginStatus.inProgress));
    axios.post(`${baseUrl}/bearers`, login)
        .then(response => {
            const data = response.data;
            localStorage.setItem('bearer', data.bearer)
            dispatch(setUserData(data.user));
            dispatch(setBearerToken(data.bearer));
            dispatch(setLoginAttempt(loginStatus.success));
        })
        .catch(error => {
            const errorMessage = error.response&&error.response.data&&error.response.data.message;
            dispatch(showError(errorMessage))
            if (errorMessage === "User is not verified")
                dispatch(setLoginAttempt(loginStatus.notVerified));
            else
                dispatch(setLoginAttempt(loginStatus.fail));
        });
}